namespace $.$$ {
	$mol_style_define( $shm_mentionstat_items, {
		flex: { grow: 1, shrink: 1 },
		minWidth: 0,
		Grid: { flex: { grow: 1, shrink: 1 }, minWidth: 0, width: '100%' },
		Cell: { whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' },
		Col_head: { whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' },
		Actions: { gap: 0 },
		Controls: {
			alignItems: 'center',
			padding: $mol_gap.block,
		},
		Status: { color: $mol_theme.shade },
	} )
}
